// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"391":"crm-leads","717":"cars-board","919":"tasks"}[chunkId] || chunkId) + "." + {"391":"ce0affe1","619":"0d737d6e","717":"14df780f","919":"46967eff","943":"3663e14b"}[chunkId] + ".css";
};